import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Breadcrumbs from 'modules/common/components/Breadcrumbs';
import { getCrumbs } from 'modules/users/modules/profiles/components/ProBreadcrumbs';

import { ProBlogPostProps } from 'components/molecules/ProBlogPost';

import styles from './ProBlogBreadcrumbs.module.scss';

interface Props {
  jobType?: {
    categories?: Array<string>;
    id: string;
    title: string;
  };
  pro: {
    location: {
      city?: { key: string; name: string };
      prefecture?: { key: string; name: string };
    };
    name?: string;
    slug: string;
  };
  proBlogPost: ProBlogPostProps;
}

const ProBlogBreadcrumbs: FC<Props> = ({
  jobType,
  pro: {
    location: { city, prefecture },
    name,
    slug,
  },
  proBlogPost,
}) => {
  const {
    i18n: { language },
  } = useTranslation();

  const crumbs = getCrumbs({
    city,
    jobType,
    language,
    prefecture,
    proName: name ?? '',
    proSlug: slug,
  });

  crumbs.push({
    link: '',
    text: proBlogPost.title ?? '',
  });

  return (
    <div className={styles['wrapper']}>
      <Breadcrumbs align="left" crumbs={crumbs} />
    </div>
  );
};

export default ProBlogBreadcrumbs;
